import request from './request';

export default request;



// WEBPACK FOOTER //
// ./src/api/xws/index.js